export default "__VITE_ASSET__B72U_01S__"